var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.55929 9.53911C7.24338 9.23022 6.73688 9.23591 6.42799 9.55182C6.11911 9.86773 6.1248 10.3742 6.44071 10.6831L7.55929 9.53911ZM12 15L11.4407 15.572L12 16.1189L12.5593 15.572L12 15ZM17.5593 10.6831C17.8752 10.3742 17.8809 9.86773 17.572 9.55182C17.2631 9.23591 16.7566 9.23022 16.4407 9.53911L17.5593 10.6831ZM12.8 4C12.8 3.55817 12.4418 3.2 12 3.2C11.5582 3.2 11.2 3.55817 11.2 4L12.8 4ZM6.44071 10.6831L11.4407 15.572L12.5593 14.428L7.55929 9.53911L6.44071 10.6831ZM12.5593 15.572L17.5593 10.6831L16.4407 9.53911L11.4407 14.428L12.5593 15.572ZM12.8 15L12.8 4L11.2 4L11.2 15L12.8 15Z",
    fill: "#FC7B52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 19.2C5.55817 19.2 5.2 19.5582 5.2 20C5.2 20.4418 5.55817 20.8 6 20.8V19.2ZM18 20.8C18.4418 20.8 18.8 20.4418 18.8 20C18.8 19.5582 18.4418 19.2 18 19.2V20.8ZM6 20.8H18V19.2H6V20.8Z",
    fill: "#FC7B52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.7d9b8def8e0b9d9744326cb9fbd0a327.svg";
export { ForwardRef as ReactComponent };